import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ChangeLang.styles';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { getReversedLangDefinition } from '@/utils/helpers';
import { useChangeLang } from '@/components/ChangeLang/useChangeLang';
import { TypographyProps } from '@/components/UI/Typography/Typography.types';

interface ChangeLangProps {
  isShort?: boolean;
  typography?: React.ElementType;
  typographyProps?: TypographyProps;
  hasIcon?: boolean;
}

export const ChangeLang: React.FC<ChangeLangProps> = ({
  isShort,
  typographyProps = {},
  typography: TypographyComponent = Typography.Body,
  hasIcon,
}) => {
  const { i18n } = useTranslation();
  const changeLang = useChangeLang();

  return (
    <S.Button
      appearance="transparent"
      onClick={changeLang}
      hasPadding={false}
      isAutoWidth
      data-testid="change-lang"
      $hasIcon={hasIcon}
    >
      <TypographyComponent {...typographyProps}>
        {isShort
          ? getReversedLangDefinition(i18n.language).short.toUpperCase()
          : getReversedLangDefinition(i18n.language).long}
      </TypographyComponent>
    </S.Button>
  );
};
